import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getPatientQuestionnaireAnswers } from '../services/patient';
import usePagination from './usePagination';

const id = 'questionnaire-answers';

export const usePatientQuestionnaireAnswers = (patientUUID, enabled = true) => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const handlerFetchData = async ({ queryKey }) => {
        const [, { patientUUID }] = queryKey;
        return getPatientQuestionnaireAnswers(
            patientUUID,
            paginationModel.pageSize,
            currentToken(paginationModel.page)
        );
    };

    const { isPending, isError, data } = useQuery({
        queryKey: [
            id,
            {
                patientUUID,
                paginationModel
            }
        ],
        queryFn: handlerFetchData,
        placeholderData: keepPreviousData,
        enabled: enabled && !!patientUUID
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data, paginationModel.page]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};
